const BASE_URL = process.env.REACT_APP_AT_API_BASE_URL || '';
const SUBSCRIPTION_KEY = process.env.REACT_APP_AT_API_SUBSCRIPTION_KEY || '';
const WS_BASE_URL = BASE_URL.replace(/^http/, 'ws');

/** APIM path prefixes (same across environments; base URL comes from env). */
export const BLOCK_MANAGEMENT_CLIENT_PATH = '/rt-cc-ui-block-mgt-client/v1';
export const BLOCK_MANAGEMENT_PATH = '/rt-cc-ui-block-mgt/v2';
export const BUS_PROXIMITY_ENGINE_PATH = '/rt-cc-ui-bus-proximity-engine/v3';
export const CARS_INTEGRATION_PATH = '/rt-cc-ui-cars-integration/v1';
export const CONFIG_PATH = '/rt-cc-ui-config/v1';
export const DISRUPTION_MANAGEMENT_PATH = '/rt-cc-ui-disruption-mgt/v2';
export const EVENT_STORE_PATH = '/rt-cc-ui-event-store/v1';
export const FLEET_PATH = '/rt-cc-ui-fleet/v1';
export const GTFS_SNAPSHOT_PATH = '/rt-cc-ui-gtfs-snap/v1';
export const GTFS_STATIC_PATH = '/rt-cc-ui-gtfs-static/v2';
export const GTFS_STREAMER_PATH = '/rt-cc-ui-streamer/v1';
export const HEALTH_PATH = '/rt-cc-ui-health/v1';
export const MONITORING_LEGACY_PATH = '/rt-cc-ui-monitoring-legacy/v2';
export const MONITORING_PATH = '/rt-cc-ui-monitoring/v1';
export const NOTIFICATION_CONTENT_PATH = '/rt-cc-ui-notification-content/v1';
export const PASSENGER_COUNT_PATH = '/rt-cc-ui-passenger-count/v1';
export const SERVICE_INFO_PATH = '/rt-cc-ui-service-info/v3';
export const STATIC_PATH = '/rt-cc-ui-static/v1';
export const STOP_MESSAGING_PATH = '/rt-cc-ui-stop-messaging/v3';
export const TRAFFIC_PATH = '/rt-cc-ui-traffic/v1';
export const TRIP_ALERTS_PATH = '/rt-cc-ui-trip-alerts/v2';
export const TRIP_HISTORY_PATH = '/rt-cc-ui-trip-history/v1';
export const TRIP_MANAGEMENT_PATH = '/rt-cc-ui-trip-mgt/v2';
export const TRIP_REPLAY_PATH = '/rt-cc-ui-trip-replay/v1';
export const VEHICLE_ALLOCATION_STREAMING_PATH = '/rt-cc-ui-vehicle-allocation-streaming/v2';
export const VEHICLE_HISTORY_PATH = '/rt-cc-ui-vehicle-history/v1';

export const SUBSCRIPTION_HEADER_NAME = 'Ocp-Apim-Subscription-Key';

export const getSubscriptionHeader = () => ({ [SUBSCRIPTION_HEADER_NAME]: SUBSCRIPTION_KEY });

export const apiUrl = path => `${BASE_URL}${path || ''}`;

export const wsUrl = (path, extraQs = '') => {
    const fullPath = `${WS_BASE_URL}${path || ''}`;
    const keyParam = `subscription-key=${encodeURIComponent(SUBSCRIPTION_KEY)}`;
    const sep = fullPath.includes('?') ? '&' : '?';
    return `${fullPath}${sep}${keyParam}${extraQs ? `&${extraQs}` : ''}`;
};

export const fetchWithSubscriptionKey = (url, options = {}) => fetch(url, {
    ...options,
    headers: {
        ...(options.headers || {}),
        ...getSubscriptionHeader(),
    },
});
